// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 15", width: "14", height: "15" }, props),
        React.createElement(React.Fragment, null,
            React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
                React.createElement("g", null,
                    React.createElement("g", null,
                        React.createElement("path", { d: "M2,11 L2,6 L6,6 L6,11 L8,11 L4,15 L0,11 L2,11 Z" }),
                        React.createElement("path", { d: "M2,13.7687798 L2.29162659,14 L2,14 L2,13.7687798 Z M7.83218678,14 L9.75882568,12 L12,12 L12,6 L6,6 L6,6 L8,6 L8,2 L4,2 L4,5 L2,5 L2,0 L9.8767457,0 L14,3.77710657 L14,14 L7.83218678,14 Z" })))))));
};
Icon.displayName = 'PaperDownArrow14x15';
export default Icon;
//# sourceMappingURL=PaperDownArrow14x15.js.map